import {t} from "@insight/toolkit-utils";
import React from "react";
import {Button} from "@insight/toolkit-react";

export default function Support(props) {
  const {account, goToHashLink} = props;

  const supportObject = [
    {
      title: (account?.supportObj?.accountTeam ? 'accountTeam' : ''),
      onClick: () => goToHashLink('/insightweb/salesRep')
    },
    {
      title: (account?.supportObj?.customerDocs ? 'Customer Documents' : ''),
      onClick: () => goToHashLink('/insightweb/customerDocs')
    }
  ];
  return supportObject.map((support) => {
    if (support?.title) {
      return <li><Button {...support}>{t(support.title)}</Button></li>
    }
  });
}
